export const MyProfileEN = {
  SEND_INVITATION_TO_CLIENT: 'Send invitation to client to access account',
  SENDED_INVITATION: 'Activation email sent. Send again.',
  GO_TO_ONBOARDING: 'Go to Onboarding of Client',
  UPDATE_MESSAGE_SUCCESS: 'Your changes successfuly saved',
  UPDATE_MESSAGE_ERROR: 'Something Wrong here',
  DEACTIVATE_ADVISOR: 'Deactivate advisor',
  ACTIVATE_ADVISOR: 'Activate advisor',
  EDIT_ADVISOR: 'Edit advisor',
  ENABLE_2FA: 'Enable two-factor authentication',
  INSTRUCTION:
    'To access the full functionality, you must enter and confirm BankID and/or enable two-factor authentication.',
  DELETE_PNUMBER: 'Delete personal number',
  ALERT_ERROR: 'Error. You have not verified your personal number.',
  ALERT_SUCCESS: 'Success. You have verified your personal number.',
  TITLE_2FA_MODAL: 'Configure Two-Factor Authentication.',
  STEP_ONE_2FA_MODAL: 'Get and install the Authenticator App.',
  STEP_ONE_2FA_MODAL_TEXT:
    'Authenticator apps and browser extension like 1Password, Authy, Microsoft Authenticator, Google Authenticator, etc. generate one-time password that are used as a second to verify your identity when prompted during sign-in.',
  STEP_TWO_2FA_MODAL: 'Scan the QR code',
  STEP_TWO_2FA_MODAL_TEXT: 'Use authenticator apps or browser to scan.',
  STEP_THREE_2FA_MODAL: 'Enter Verification Code',
  STEP_THREE_2FA_MODAL_TEXT:
    'Once the barcode above is scanned, enter the 6-digit verification code generated by the app.',
  TWO_FACTOR_ACTIVATE_BTN: 'Verify Code and Activate',
  DELETE_CLIENT: 'Delete client',
  CREATED_DATE: 'Created Date',
  ACTION: 'Action',
  INVITATION: 'Invitation',
  ONBOARDING: 'Onboarding',
  UNSAVED_CHANGES: 'Unsaved changes',
  YOU_WANT_WITHOUT_SAVING_ON:
    'You are about to leave this page without saving.',
  YOU_WANT_WITHOUT_SAVING_TWO:
    'All changes will be lost. Do you want to leave without saving?',
  LEAVE_WITHOUT_SAVING: 'Leave without saving',
  MODAL_DELETE_TITLE: 'Confirm deletion',
  MODAL_DELETE_TEXT: 'Are you sure you want to delete advisor',
  MODAL_DELETE_PERSON: 'Are you sure you want to delete related person',
  MODAL_DELETE_TEXT_ASSET: 'Are you sure you want to delete asset class',
  MODAL_DELETE_TEXT_CLIENT: 'Are you sure you want to delete client',
  MODAL_DELETE_PORTFOLIO: 'Are you sure you want to delete the portfolio:',
  LOCKED_PORTFOLIO_DELETE:
    'This portfolio can’t be deleted because it’s part of a composite portfolio. \nPlease remove it from the composite portfolio before proceeding',
  ENGLISH: 'English',
  SVENSKA: 'Svenska',
  LANGUAGE: 'Language',
  MODAL_DELETE_PLAN: 'Are you sure you want to delete the financial plan:',
  MODAL_DELETE_PLAN_STAGE: 'Are you sure you want to delete the stage:',
  DELETE_PLAN_STAGE_AT: 'at financial plan:',
  TOTAL_INCOME: 'total Income',
  AVERAGE_ANNUAL_INCOME: 'Average annual income',
  SPEND: 'spend',
  INCOME: 'income',
  TOTAL_SPEND: 'total Spend',
  AVERAGE_ANNUAL_SPEND: 'Average annual spend',
  HOME_BASE: 'Home Base',
  HEALTH_AND_PROTECTION: 'Health & Protection',
  MOBILITY: 'Mobility',
  CORE_SUPPORT: 'Core Support',
  BASIC_FOOD: 'Basic Food',
  BASIC_CLOTHING: 'Basic Clothing',
  CHILDREN_AND_EDUCATION: 'Children & Education',
  FOOD_AND_DRINK_OUT: 'Food & Drink Out',
  STYLE_AND_SELF: 'Style & Self',
  LEARNING_AND_GROWTH: 'Learning & Growth',
  TECH_AND_SUBSCRIPTIONS: 'Tech & Subscriptions',
  GETAWAYS_AND_HOLIDAYS: 'Getaways & Holidays',
  BIG_BUYS_AND_TOYS: 'Big Buys & Toys',
  EVENTS_AND_EXPERIENCES: 'Events & Experiences',
  GIFTS_AND_GIVING: 'Gifts & Giving',
  SALARY: 'Salary',
  PENSION: 'Pension',
  OTHER_INCOME: 'Other Income',
  PROPERTY_SALES: 'Property Sales',
  RETURN_ON_INVESTMENT: 'Return on Investment',
  OTHER_SALE: 'Other Sale',
  INHERITANCE: 'Inheritance',
  PREV: 'Prev',
  NEXT: 'Next',
  GIVE_IT_A_NAME: 'Give it a name.',
  WHAT_SORT_OF_BUDGET_ARE_YOU_THINKING: 'What sort of budget are you thinking?',
  HOW_OFTEN_DO_YOU_WANT_TO_GO: 'How often do you want to go?',
  WHEN_DO_YOU_WANT_TO_DO_IT: 'When do you want to do it?',
  WHAT_LEVEL_OF_HAPPINESS_DOES_THIS_TRIP_PROVIDE_YOU_WITH:
    'What level of happiness does this trip provide you with?',
  NOW_RANK_THIS_TRIP_IN_TERM_OF_PURPOSE:
    'Now rank this trip in term of purpose.',
  AND_LASTLY_WHERE_DOES_IT_RANK_IN_TERMS_OF_NEED_VS_WANT:
    'And lastly, where does it rank in terms of need vs want?',
  HOW_CERTAIN_ARE_YOU_ABOUT_THIS_SALE: 'How certain are you about this sale?',
  VALIDATION_ERROR: 'Validation error',
  VALIDATION_ERROR_TEXT: 'Please fill in all required fields. Errors: ',
  END_DATE_AFTER_START: 'End date after start date',

  BASE_SALARY: 'Base Salary',
  BONUS_COMMISSION: 'Bonus/Commission',
  EMPLOYER_BENEFITS: 'Employer Benefits',
  DIVIDENDS_AND_INTEREST: 'Dividends & Interest',
  REALIZED_GAINS: 'Realized Gains',
  RENTAL_INCOME: 'Rental Income',
  FREELANCE_SIDE_INCOME: 'Freelance / Side Income',
  PENSION_TRANSFERS: 'Pension / Transfers',
  GIFTS_ONE_OFF_INCOME: 'Gifts / One-off Income',
};
